import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class RefreshChatArgs extends ActionArgs {
  @Field(() => String)
  chatId: string

  @Field(() => String, { nullable: true })
  messageId?: string
}

export interface IRefreshChat extends IAction<Chat, RefreshChatArgs> {}
